/**
 * Wraps all Evaluation components in a default container. If you want to
 * give all Evaluation views a sidebar for example, you would set that here. 
 */

// import primary libraries
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import DefaultLayout from "../../../global/components/DefaultLayout.js.jsx";

class EvaluationLayout extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="master-layout">
        {this.props.children}
      </div>
    )
  }
}

export default EvaluationLayout;



// WEBPACK FOOTER //
// modules/evaluation/components/EvaluationLayout.js.jsx